export enum ROLES {
  trainerAdmin = 'trainerAdmin',
  superAdmin = 'superAdmin',
  user = 'user',
}
